exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-dialog {\n    overflow-y: initial !important;\n}\n.modal-body {\n    max-height: 50vh;\n    overflow-y: auto;\n}\n.modal-console .modal-body {\n    overflow: hidden;\n}\n.modal-console .modal-body pre {\n    max-height: calc(50vh - 40px);\n    background: #333;\n    color: #f5f5f5;\n}\n", ""]);

// exports
